import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=0d12316d&scoped=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=0d12316d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12316d",
  null
  
)

export default component.exports